import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import './translations/i18n';

import reportWebVitals from './reportWebVitals';
import { AppRouter } from './router/Approuter';
import { store } from './store';

import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRouter />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root') as HTMLElement,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
